import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
`;

export const MainContainer = styled.main`
  margin: 20px;
`;
